import { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle2, Download, Mail } from "lucide-react";
import { AUTHOR_EMAIL, DOWNLOAD_URL, getCookie, PRODUCT_NAME } from "../lib/site";

const STEPS = [
  "Pobierz i rozpakuj pakiet (pliki DOC + PDF)",
  "Uzupełnij oznaczone pola danymi swojego lokalu",
  "Przechowuj dokumenty w lokalu — gotowe na każdą kontrolę",
];

export const ThankYou = () => {
  useEffect(() => {
    if (sessionStorage.getItem("purchaseTracked")) return;
    sessionStorage.setItem("purchaseTracked", "1");
    const eventId = crypto.randomUUID();
    if (window.fbq)
      window.fbq("track", "Purchase", { value: 219, currency: "PLN" }, { eventID: eventId });
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/purchase`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event_id: eventId,
        event_source_url: window.location.href,
        fbp: getCookie("_fbp"),
        fbc: getCookie("_fbc"),
      }),
      keepalive: true,
    }).catch(() => {});
  }, []);

  return (
  <main
    data-testid="thank-you-page"
    className="flex min-h-screen items-center justify-center bg-choc-deep px-6 py-16"
  >
    <motion.div
      className="w-full max-w-lg text-center"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    >
      <span className="inline-flex h-20 w-20 items-center justify-center rounded-full bg-brick/20">
        <CheckCircle2 className="h-10 w-10 text-brick-soft" />
      </span>
      <h1 className="mt-8 font-display text-4xl font-semibold tracking-tight text-cream sm:text-5xl">
        Dziękujemy za zakup!
      </h1>
      <p className="mt-4 text-sm leading-relaxed text-cream/70 sm:text-base">
        {PRODUCT_NAME} jest Twój. Pobierz dokumenty i uzupełnij oznaczone pola
        danymi swojego lokalu.
      </p>

      <a
        data-testid="download-package-button"
        href={DOWNLOAD_URL}
        download
        className="group mt-10 inline-flex items-center gap-3 rounded-full bg-brick px-9 py-5 text-base font-semibold text-white transition-colors duration-300 hover:bg-brick-dark sm:text-lg"
      >
        <Download className="h-5 w-5 transition-transform duration-300 group-hover:translate-y-0.5" />
        Pobierz pakiet (DOC + PDF)
      </a>

      <ol className="mx-auto mt-12 max-w-sm space-y-4 text-left">
        {STEPS.map((step, i) => (
          <li key={step} data-testid={`thank-you-step-${i}`} className="flex items-start gap-4">
            <span className="font-display text-xl italic text-brick-soft">{i + 1}.</span>
            <span className="text-sm leading-relaxed text-cream/80">{step}</span>
          </li>
        ))}
      </ol>

      <p className="mt-10 flex items-center justify-center gap-2 text-xs text-cream/55 sm:text-sm">
        <Mail className="h-4 w-4 shrink-0" />
        Potwierdzenie otrzymasz też e-mailem. Pytania: {AUTHOR_EMAIL}
      </p>
      <Link
        data-testid="thank-you-back-link"
        to="/"
        className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-brick-soft transition-colors duration-300 hover:text-white"
      >
        <ArrowLeft className="h-4 w-4" />
        Wróć na stronę główną
      </Link>
    </motion.div>
  </main>
  );
};
